import {
  resetReadTasksReadTasksResetPatch,
  ResetReadTasksReadTasksResetPatchResponse,
  ResetReadTasksReadTasksResetPatchData,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useResetTasksMutation = (): UseMutationResult<
  ResetReadTasksReadTasksResetPatchResponse,
  AxiosError<HTTPValidationError>,
  ResetReadTasksReadTasksResetPatchData
> => {
  return useMutation<
    ResetReadTasksReadTasksResetPatchResponse,
    AxiosError<HTTPValidationError>,
    ResetReadTasksReadTasksResetPatchData
  >({
    mutationFn: async (body) => {
      const response = await resetReadTasksReadTasksResetPatch({
        query: body.query,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ReadTasksList'] })
    },
  })
}
